import React, { useEffect, useState } from 'react';

import ProgramCarouselSection from '../../../../shared/ProgramCarouselSection/ProgramCarouselSection';
import type { ProgramItem } from '../../../../shared/ProgramCarouselSection/ProgramCarouselSection.types';

import { getLatestUpdatedPrograms } from '../../../../../services/api/contentLatestUpdatedPrograms';

const PROGRAMS_PATH = '/programas';
const PROGRAMS_LIMIT = 8;

export default function ProgramViewProgramsCarousel() {
  const [items, setItems] = useState<ProgramItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;

    async function loadPrograms() {
      setLoading(true);

      const result = await getLatestUpdatedPrograms();

      if (isMounted) {
        setItems(result.slice(0, PROGRAMS_LIMIT));
        setLoading(false);
      }
    }

    loadPrograms();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <ProgramCarouselSection
      items={items}
      loading={loading}
      title="Programas"
      subtitle="Conheça os programas que fazem parte da nossa grade"
      href={PROGRAMS_PATH}
      actionLabel="Ver todos"
      emptyMessage={`Nenhum programa publicado encontrado em ${PROGRAMS_PATH}`}
    />
  );
}
